import { Icon } from "@iconify/react";
import React from "react";

export default function CustomButtonHtml({ icon, title, onClickBtn }) {
  return (
    <div
      className="border text-center p-1 cursor-pointer flex flex-col items-center bg-white rounded-md active:opacity-50 hover:opacity-80"
      onClick={() => {
        onClickBtn();
      }}
    >
      <Icon icon={icon} className="text-black text-3xl" />
      <p>{title}</p>
    </div>
  );
}
